import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class CapitalContainer extends ShadowDOMElement {
	static className = "CapitalContainer";
	
	static properties = {
		checked: { type: Boolean }
	};

	constructor() {
		super();
		this.checked = false;
	}

	render() {
    return html`
      <big-checkbox-field data-checkbox label="Capital variable" @change="${this.handleCheckboxChange}" ?checked="${this.checked}" name="variable_capital"></big-checkbox-field>
      <row-wrapper data-container-1>
        <number-field label="Capital (en euros) *" required name="capital"></number-field>
      </row-wrapper>
      <row-wrapper data-container-2>
        <number-field
          label="Montant en dessous duquel le capital ne peut être réduit (en euros) *"
          required
		  name="min_capital_amount"
        ></text-field>
      </row-wrapper>
    `;
  	}

	firstUpdated() {
		this.checkbox = this.shadowRoot.querySelector("[data-checkbox]");
		this.row1 = this.shadowRoot.querySelector("[data-container-1]");
		this.row2 = this.shadowRoot.querySelector("[data-container-2]");

		this.updateVisibility();
	}

	handleCheckboxChange(event) {
		if (event && event.detail){
			this.checked = event.detail.checked;
			this.updateVisibility();
		}
	}

	updateVisibility() {
		if (this.checked) {
			this.row1.style.display = "none";
			this.row2.style.display = "";
		} else {
			this.row1.style.display = "";
			this.row2.style.display = "none";
		}
	}
	
	isTransient (){
		return false;
	}
	
	getValues (){
		return {"checked" : this.checked, ... super.getValues ()};
	}
	
	setValues (values){
		super.setValues (values);
		this.checked = values.checked;
		this.updateVisibility ();
	}
}

customElements.define ("capital-container", CapitalContainer);
